module.exports = __webpack_public_path__ + "img/right_3.5c7a3a6c.jpg";